<template>
	<ui-modal-template>
		<template v-slot:header>
			<div class="px-6 py-4">
				<div class="flex flex-col sm:flex-row sm:pr-4 sm:mr-6">
					<div
						:class="[
							'mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full sm:mx-0 bg-red-100 mb-3 sm:mr-3',
						]"
					>
						<!-- sm:h-5 sm:w-5 -->
						<ui-icon
							name="alert-triangle"
							class="h-8 w-8 text-red-600"
							stroke-width="2"
						/>
					</div>
					<div class="px-3">
						<h3
							class="text-2xl text-black text-center sm:text-left font-semibold"
						>
							Sind sie sicher?
						</h3>
						<p class="mt-2 text-center sm:text-left">
							Soll der Eintrag gelöscht werden?
						</p>
					</div>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5 hidden sm:inline-block"
					v-on:click="$bus.$emit('modal:close')"
				>
					<ui-icon class="h-9 w-9" name="x" stroke-width="2" />
				</ui-button>
			</div>
		</template>

		<template v-slot:content>
			<form
				class="pb-6 px-6 flex flex-col flex-col-reverse sm:flex-row sm:flex-row justify-end gap-y-3 gap-x-3"
			>
				<ui-button
					type="secondary"
					class="w-full sm:w-auto text-lg"
					v-on:click="$bus.$emit('modal:close')"
					>Nein</ui-button
				>

				<ui-button
					:class="['w-full sm:w-auto text-lg bg-red-500 hover:bg-red-600']"
					type="primary"
					v-on:click="submitForm()"
					>Löschen</ui-button
				>
			</form>
		</template>
	</ui-modal-template>
</template>

<script lang="ts">
import axios from "axios";
export default {
	props: {
		id: {
			required: true,
			type: Number,
		},
	},
	methods: {
		submitForm() {
			const route = this.$route("sale_intentions.delete", { id: this.id });

				axios.post(route)
					.then(this.onSuccess)
					.catch(this.onError);
		},
		onSuccess(result) {
			this.$bus.$emit("page:content:load");
			this.$bus.$emit("modal:close");
		},
		onError(error) {
			console.log("error ok", error);
		},
	},
};
</script>
